import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAxiosAuth } from "@/lib/auth-token";

// Install axios auth (Bearer token + cookies fallback) before any component renders.
installAxiosAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
